module.exports = __webpack_public_path__ + "img/caret-up-fill.0eb807cc.svg";